"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHoliday = exports.getHolidays = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const util_1 = require("./common/util");
const getHolidays = (year) => {
    if (year < 1885) {
        return [];
    }
    const holidays = [];
    const newYearsDay = NewYearsDay(year);
    newYearsDay && holidays.push(newYearsDay);
    const martinLutherKingJrDay = MartinLutherKingJrDay(year);
    martinLutherKingJrDay && holidays.push(martinLutherKingJrDay);
    const lincolnsBirthday = LincolnsBirthday(year);
    lincolnsBirthday && holidays.push(lincolnsBirthday);
    const washingtonsBirthday = WashingtonsBirthday(year);
    washingtonsBirthday && holidays.push(washingtonsBirthday);
    const goodFriday = GoodFriday(year);
    goodFriday && holidays.push(goodFriday);
    const memorialDay = MemorialDay(year);
    memorialDay && holidays.push(memorialDay);
    const juneteenthDay = JuneteenthDay(year);
    juneteenthDay && holidays.push(juneteenthDay);
    const independenceDay = IndependenceDay(year);
    independenceDay && holidays.push(independenceDay);
    const laborDay = LaborDay(year);
    laborDay && holidays.push(laborDay);
    const columbusDay = ColumbusDay(year);
    columbusDay && holidays.push(columbusDay);
    const electionDay = ElectionDay(year);
    electionDay && holidays.push(electionDay);
    const veteransDay = VeteransDay(year);
    veteransDay && holidays.push(veteransDay);
    const thanksgivingDay = ThanksgivingDay(year);
    thanksgivingDay && holidays.push(thanksgivingDay);
    const christmasDay = ChristmasDay(year);
    christmasDay && holidays.push(christmasDay);
    const result = holidays
        .map((holiday) => {
        if (holiday.date.day() === 0) {
            return Object.assign(Object.assign({}, holiday), { date: holiday.date.add(1, "day") });
        }
        if (holiday.date.day() === 6) {
            const observed = holiday.date.subtract(1, "day");
            if (holiday.date.isBefore((0, util_1.getDate)({ year: 1959, month: 7, day: 3 }))) {
                return Object.assign(Object.assign({}, holiday), { date: observed });
            }
            else if (observed.month() === holiday.date.month()) {
                return Object.assign(Object.assign({}, holiday), { date: observed });
            }
        }
        return holiday;
    })
        .filter((holiday) => holiday.date.day() !== 6)
        .map((holiday) => {
        return Object.assign(Object.assign({}, holiday), { date: holiday.date.toDate(), dateString: holiday.date.format("YYYY-MM-DD") });
    });
    return result;
};
exports.getHolidays = getHolidays;
const isHoliday = (date) => {
    const year = (0, dayjs_1.default)(date).year();
    return ((0, exports.getHolidays)(year).some((holiday) => holiday.date.toDateString() === date.toDateString()) ||
        (0, exports.getHolidays)(year + 1).some((holiday) => holiday.date.toDateString() === date.toDateString()));
};
exports.isHoliday = isHoliday;
const NewYearsDay = (year) => {
    return { name: "New Years Day", date: (0, util_1.getDate)({ year, month: 1, day: 1 }) };
};
const MartinLutherKingJrDay = (year) => {
    if (year >= 1998) {
        return {
            name: "Martin Luther King, Jr. Day",
            date: (0, util_1.getNthDay)({ n: 3, year, month: 1, day: 1 }),
        };
    }
};
const LincolnsBirthday = (year) => {
    if (year >= 1896 && year <= 1953) {
        return {
            name: "Lincoln's Birthday",
            date: (0, util_1.getDate)({ year, month: 2, day: 12 }),
        };
    }
};
const WashingtonsBirthday = (year) => {
    const name = "Washington's Birthday";
    if (year > 1971) {
        return {
            name,
            date: (0, util_1.getNthDay)({ n: 3, year, month: 2, day: 1 }),
        };
    }
    return {
        name,
        date: (0, util_1.getDate)({ year, month: 2, day: 22 }),
    };
};
const GoodFriday = (year) => {
    if (year === 1898 || year === 1906 || year === 1907) {
        return undefined;
    }
    return {
        name: "Good Friday",
        date: (0, util_1.getGoodFriday)({ year }),
    };
};
const MemorialDay = (year) => {
    const name = "Memorial Day";
    if (year >= 1971) {
        return {
            name,
            date: (0, util_1.getLastDay)({ year, month: 5, day: 1 }),
        };
    }
    else if (year >= 1873) {
        return {
            name,
            date: (0, util_1.getDate)({ year, month: 5, day: 30 }),
        };
    }
};
const JuneteenthDay = (year) => {
    if (year >= 2022) {
        return {
            name: "Juneteenth National Independence Day",
            date: (0, util_1.getNextPreviousWorkDay)({ year, month: 6, day: 19 }),
        };
    }
};
const IndependenceDay = (year) => {
    return {
        name: "Independence Day",
        date: (0, util_1.getDate)({ year, month: 7, day: 4 }),
    };
};
const LaborDay = (year) => {
    if (year >= 1887) {
        return {
            name: "Labor Day",
            date: (0, util_1.getNthDay)({ n: 1, year, month: 9, day: 1 }),
        };
    }
};
const ColumbusDay = (year) => {
    if (year >= 1909 && year <= 1953) {
        return {
            name: "Columbus Day",
            date: (0, util_1.getDate)({ year, month: 10, day: 12 }),
        };
    }
};
const ElectionDay = (year) => {
    if (year <= 1968 || year === 1972 || year === 1976 || year === 1980) {
        const date = (0, util_1.getNthDay)({ n: 1, year, month: 11, day: 1 }).add(1, "day");
        return {
            name: "Election Day",
            date,
        };
    }
};
const VeteransDay = (year) => {
    if (year === 1918 || year === 1921 || (year >= 1934 && year <= 1953)) {
        return {
            name: "Veterans Day",
            date: (0, util_1.getDate)({ year, month: 11, day: 11 }),
        };
    }
};
const ThanksgivingDay = (year) => {
    return {
        name: "Thanksgiving Day",
        date: (0, util_1.getNthDay)({ n: 4, year, month: 11, day: 4 }),
    };
};
const ChristmasDay = (year) => {
    return { name: "Christmas Day", date: (0, util_1.getDate)({ year, month: 12, day: 25 }) };
};
